import { jsx as e } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8536 7.85355C16.0488 7.65829 16.0488 7.34171 15.8536 7.14645C15.6583 6.95118 15.3417 6.95118 15.1464 7.14645L7.14645 15.1464C6.95118 15.3417 6.95118 15.6583 7.14645 15.8536C7.34171 16.0488 7.65829 16.0488 7.85355 15.8536L15.8536 7.85355ZM15.8536 11.8536C16.0488 11.6583 16.0488 11.3417 15.8536 11.1464C15.6583 10.9512 15.3417 10.9512 15.1464 11.1464L11.1464 15.1464C10.9512 15.3417 10.9512 15.6583 11.1464 15.8536C11.3417 16.0488 11.6583 16.0488 11.8536 15.8536L15.8536 11.8536Z",
        fill: "#92929B"
      }
    )
  }
);
export {
  o as DragIcon
};
//# sourceMappingURL=DragIcon.js.map
